import { SizedStringVO, SIZES } from '../helpers/sized-string.js';
const SLUG_REGEX = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
export const SlugVO = {
    SM: SizedStringVO(SIZES.SM).regex(SLUG_REGEX),
    MD: SizedStringVO(SIZES.MD).regex(SLUG_REGEX),
    LG: SizedStringVO(SIZES.LG).regex(SLUG_REGEX),
};
//# sourceMappingURL=slug.js.map